// extracted by mini-css-extract-plugin
export default {"struttura":"SelectAutocomplete_struttura__EOM5n"};